import React, { FC, ReactElement } from 'react'
import styles from './SatributeModal.module.css'
import Modal from '@/components/icon-modal'
import DollarIcon from '@/icons/dollar'
import SatributeCard from '@/components/satribute-modal/satribute-card'

const SatributeModal: FC<{ open: boolean; onClose: (evt: any) => void }> = (
	props
): ReactElement => {
	const satributes = [
		{ title: 'Uncommon', icon: '💎', description: 'First sat of each block' },
		{ title: 'Rare', icon: '💠', description: 'First sat of each difficulty adjustment period' },
		{ title: 'Epic', icon: '❇️', description: 'First sat of each halving epoch' },
		{ title: 'Vintage', icon: '⏳', description: 'Sat mined in the first 1,000 blocks' },
		{ title: 'Nakamoto', icon: '🥷', description: 'Sat mined by Satoshi Nakamoto' },
		{
			title: 'First Transaction',
			icon: '🥇',
			description:
				'Sat from the 10 BTC sent from Satoshi Nakamoto to Hal Finney in the first Bitcoin transaction ever on January 12, 2009'
		},
		{
			title: 'Palindrome',
			icon: '🦋',
			description: 'Sat whose number reads the same backward or forward'
		},
		{
			title: 'Pizza',
			icon: '🍕',
			description: "Sat from the 10,000 BTC used to purchase two Papa John's pizzas on May 22, 2010"
		},
		{
			title: 'Block 9',
			icon: '9️⃣',
			description:
				"Sat mined in block 9 which are the oldest sats in circulation unless Satoshi's wallet wakes up"
		},
		{
			title: 'Block 78',
			icon: '7️⃣8️⃣',
			description:
				'Sat mined by Hal Finney in block 78 which was the first block mined by someone other than Satoshi',
			emojiClassName: styles.twoEmojis
		}
	]

	const renderSatributes = (s: any) => {
		return (
			<SatributeCard
				emojiClassName={s.emojiClassName}
				title={s.title}
				description={s.description}
				icon={s.icon}
			/>
		)
	}

	return (
		<Modal
			open={props.open}
			title={'Satributes'}
			icon={() => <DollarIcon />}
			onClose={props.onClose}
			bodyClassName={styles.root}
			titleClassName={styles.title}
			iconContainerClassName={styles.icon}
			footerButtonText="Close"
		>
			{satributes.map(renderSatributes)}
		</Modal>
	)
}

export default SatributeModal
